/** 공통 포맷 헬퍼. */

/**
 * 초 → 'Hh Mm Ss' / 'Mm Ss' / 'Ss'.
 *  - null / undefined / 0 / NaN → '—'
 *  - <60      → '12s'
 *  - <3600    → '12m 34s' (초가 0이면 '12m')
 *  - 그 이상  → '1h 23m 45s' (분/초 0 생략)
 */
export function formatEta(sec: number | null | undefined): string {
  if (sec == null || !Number.isFinite(sec) || sec <= 0) return '—'
  const s = Math.floor(sec)
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const r = s % 60
  const parts: string[] = []
  if (h) parts.push(`${h}h`)
  if (m) parts.push(`${m}m`)
  if (r || parts.length === 0) parts.push(`${r}s`)
  return parts.join(' ')
}
